import React from 'react';

import { LargeEurobandCarRegistrationNumberControlProps } from './LargeEurobandCarRegistrationNumberControl.interfaces';
import { EurobandCarRegistrationNumberControl } from 'app/components/Controls';

export default function LargeEurobandCarRegistrationNumberControl(
  props: LargeEurobandCarRegistrationNumberControlProps
) {
  return <EurobandCarRegistrationNumberControl {...props} large />;
}
